import React from "react";
import "./UnifiedLoading.css";

const UnifiedLoading = ({
  visible = true,
  variant = "fullscreen", // fullscreen | section | inline
  municipalityName = "Arsuz Belediyesi",
  logoSrc = null,
  title = "Yükleniyor",
  subtitle = "Lütfen bekleyiniz...",
  message = "",
  size = "md", // sm | md | lg
  overlay = true,
  className = "",
}) => {
  if (!visible) return null;

  const rootClassName = [
    "uload",
    `uload--${variant}`,
    `uload--${size}`,
    overlay ? "uload--overlay" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  const LoaderCore = (
    <div
      className="uload__content"
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      {(variant === "fullscreen" || variant === "section") && (
        <div className="uload__card">
          <div className="uload__logo-wrap" aria-hidden="true">
            {logoSrc ? (
              <img src={logoSrc} alt="" className="uload__logo" />
            ) : null}
            {/* TEK animasyon: logonun etrafında dönen sade halka */}
            <span className="uload__logo-spinner" />
          </div>

          {variant === "fullscreen" && (
            <div className="uload__municipality">{municipalityName}</div>
          )}

          <div className="uload__title">{title}</div>

          {(subtitle || message) && (
            <div className="uload__subtitle">
              {subtitle}
              {message ? <span className="uload__message"> {message}</span> : null}
            </div>
          )}

        </div>
      )}

      {variant === "inline" && (
        <div className="uload__inline" role="status" aria-live="polite">
          <span className="uload__inline-spinner" aria-hidden="true" />
          <span className="uload__inline-text">{title}</span>
        </div>
      )}
    </div>
  );

  if (variant === "fullscreen") {
    return <div className={rootClassName}>{LoaderCore}</div>;
  }

  if (variant === "section") {
    return <div className={rootClassName}>{LoaderCore}</div>;
  }

  return <span className={rootClassName}>{LoaderCore}</span>;
};

export default UnifiedLoading;